// extracted by mini-css-extract-plugin
export var bodyRow = "_cs-d";
export var cardColumns = "_cs-e";
export var ellipsesOverflow = "_cs-2";
export var flatBottomCorners = "_cs-3";
export var flatTopCorners = "_cs-4";
export var headerActionsDropdown = "_cs-f";
export var headerBottomRow = "_cs-c";
export var headerTopRow = "_cs-b";
export var orderDetailsWrapper = "_cs-0";
export var orderInfoContainer = "_cs-1";
export var productDetails = "_cs-9";
export var productImage = "_cs-5";
export var responsiveTable = "_cs-8";
export var shipmentContainer = "_cs-a";
export var tableBottomLeft = "_cs-6";
export var tableBottomRight = "_cs-7";
export var trackingLink = "_cs-g";